import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesIntegracoes {
  ler: boolean;
  gerenciar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `integracoes`
 * (`apps/api/src/modules/integracoes/integracoes.routes.ts`): nenhum
 * papel além de `admin` (curinga `*`) foi seedado — conectar/desconectar
 * um provedor externo de frete é decisão administrativa, mesmo critério
 * de `automacoes` e `integracoes-legado`.
 */
export function permissoesIntegracoes(papel: PapelUsuario): PermissoesIntegracoes {
  if (papel === 'admin') return { ler: true, gerenciar: true };
  return { ler: false, gerenciar: false };
}
